<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span>Chicago Studies in Ethnomusicology</p>
<p class="sered"><i>A series edited by Philip V. Bohlman and Timothy Rommen</i></p>
<p class="serah"><i>Editorial Board</i></p>
<p class="sered">Margaret J. Kartomi</p>
<p class="sered">Anthony Seeger</p>
<p class="sered">Kay Kaufman Shelemay</p>
<p class="sered">Martin H. Stokes</p>
<p class="sered">Bonnie C. Wade</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lie-0003.vue?2fd3ec9c